export default "__VITE_ASSET__BiB85uBm__"